/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { DatePipe } from '@angular/common';
import { CommonUtils } from '../../tool/common-utils';
import { CalendarTask } from './calendar-task';

export class CalendarResourcesDay {
  public date: Date;
  public height: number;
  public day: string;
  public weekDay: string;
  public month: string;
  public grayed: boolean;
  public isCurrentDay: boolean;
  public backgroundColor: string;
  public hasTelework = false;
  public totalTasksDuration = 0;

  constructor(date: Date) {
    const pipe = new DatePipe('fr');
    this.date = date;
    this.day = pipe.transform(date, 'dd');
    this.isCurrentDay = CommonUtils.compareDate(this.date, new Date());
    this.weekDay = pipe.transform(date, 'EEEE');
    this.month = pipe.transform(date, 'MMM, yyyy');
    this.height = 60;
  }

  private computeHeight(count: number) {
    setTimeout(() => {
      const requiredHeight = count * 27 + 10;
      if (requiredHeight > this.height) {
        this.height = requiredHeight;
      }
    }, 0);
  }

  clear() {
    this.height = 60;
    this.totalTasksDuration = 0;
  }

  setCount(count: number) {
    this.computeHeight(count);
  }

  setDuration(tasks: CalendarTask[]) {
    let total = 0;
    for (const task of tasks) {
      const taskDuration = CommonUtils.convertStrToTime(task.getDuration())
      total += (taskDuration.hours * 60 + taskDuration.minutes)
    }
    this.totalTasksDuration = total;
  }
}
